import { Component, Input } from '@angular/core';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { DatePipe, Location } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';
import { SpecificDanoneService } from 'src/app/assabil-sales/services/specific_danone_service';
import { Partnercluster } from 'src/app/assabil-sales/models/entities/partnercluster';



@Component({
  selector: 'excluded-partner-list',
  templateUrl: './excluded-partner-list.component.html',
  styleUrls: ['./excluded-partner-list.component.scss']
})
export class ExcludedPartnerListComponent extends BasePage2<Partnercluster> {

  
  @Input() startDateDetail          : Date;
  @Input() endDateDetail            : Date;
  @Input() partnerclusterCode : string;
  @Input() productCode        : string;
  @Input() brandCode          : string;
  @Input() geoAreaCode        : string;
  @Input() geoAreaName        : string;
  @Input() kpi                : string;

  // Filter fields
  // -------------------------------------------------------------------------------------
  excluded           : boolean;

  // -------------------------------------------------------------------------------------
  danoneExcludedPartnerLists : any[] = [];
  // -------------------------------------------------------------------------------------

  title = "";
  // -------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------

  constructor(
      protected datepipe: DatePipe,
      protected toastr            : ToastrService,
      protected router            : Router,
      protected baseService       : BaseService,
      protected leanUtilsService  : LeanUtilsService,
      protected specificDanoneService    : SpecificDanoneService,
      protected location          : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "excludedPartnerList";
  }
//--------------------------------------------------------------------------------------------------------

  
//--------------------------------------------------------------------------------------------------------
  ngOnInit() {
    //assigner periodActiveDay !!!!
    
    if (! this.embeded) return;
    this.loadData();
    
    if (this.productCode == "%") {
      this.title = "Clients exclus du: " + this.datepipe.transform(this.startDateDetail, 'dd/MM/yyyy') + " au: " + this.datepipe.transform(this.endDateDetail, 'dd/MM/yyyy')  + " | " + this.geoAreaName + " | Gamme: " + this.brandCode + " | Cluster: " + this.partnerclusterCode
    } else {
      this.title = "Clients exclus du: " + this.datepipe.transform(this.startDateDetail, 'dd/MM/yyyy') + " au: " + this.datepipe.transform(this.endDateDetail, 'dd/MM/yyyy')  + " | " + this.geoAreaName + " | SKU: " + this.productCode + " | Cluster: " + this.partnerclusterCode
    }
  }
//--------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------
getRows(): Partnercluster[] {
      return this.danoneExcludedPartnerLists;
  }
//--------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------
loadData() {

  this.excluded = false;
 
  if (this.kpi === "Excluded")
    this.excluded = true;
  
   this.specificDanoneService.danoneExcludedPartnerListsGet(this.startDateDetail, this.endDateDetail, this.geoAreaCode, 
    this.productCode, this.brandCode, this.partnerclusterCode, this.excluded).then(result => {
      this.danoneExcludedPartnerLists = result;
  })
}
//--------------------------------------------------------------------------------------------------------

}

